var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"eventSchedule"},[_c('Breadcrumb'),_c('el-main',[_c('EventDesc'),_c('el-row',{staticClass:"nofull event_content"},[_c('EventMenu',{attrs:{"menuActiveId":_vm.menuActiveId}}),_c('el-main',[(
            _vm.eventDesc.setting_json.schedule === '' ||
            _vm.eventDesc.setting_json.schedule === '<p></p>' ||
            _vm.eventDesc.setting_json.schedule === null ||
            _vm.eventDesc.setting_json.schedule === undefined
          )?_c('div',{staticClass:"contentEmpty"},[_vm._v(" 暂无内容 ")]):_c('div',{staticClass:"muContent",domProps:{"innerHTML":_vm._s(_vm.eventDesc.setting_json.schedule)}})])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }